import { render, staticRenderFns } from "./SassVariablesTable.vue?vue&type=template&id=ca0a2052&"
import script from "./SassVariablesTable.vue?vue&type=script&lang=js&"
export * from "./SassVariablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports